import { Alert, FormControl, InputLabel, MenuItem } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { Booth, presentationSlotTypes } from '../../../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../../../reduxToolkit/typedRedux';
import VySelect from '../../../../../../../common/VySelect';

export const BoothSelect = ({ videoType }: { presentationSlotType: presentationSlotTypes; videoType: 'livestream' | 'videoconference' }) => {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const booths = useSelector((state) => state.common.booths);

  return (
    <>
      {booths && booths.length < 1 && (
        <Alert className="mt-2" severity="info">
          {t('account:presentation.no-booth')}
        </Alert>
      )}

      <Controller
        name="booth"
        control={control}
        defaultValue={videoType === 'videoconference' ? booths?.[0]?._id : 0}
        render={({ field: { onChange, value, ref } }) => (
          <FormControl fullWidth>
            <InputLabel id="booth-label">{t('account:booth')}</InputLabel>
            <VySelect
              required={videoType === 'videoconference'}
              labelId="booth-label"
              value={value}
              onChange={onChange}
              inputRef={ref}
              label={t('account:booth')}
              variant="outlined">
              <MenuItem disabled={videoType === 'videoconference'} value={0} className={videoType === 'videoconference' ? 'text-slate-400 italic' : ''}>
                {t('account:none')}
              </MenuItem>

              {booths?.map((booth: Booth) => (
                <MenuItem value={booth?._id}>{booth.name}</MenuItem>
              ))}
            </VySelect>
          </FormControl>
        )}
      />
    </>
  );
};
